"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
exports.styles = {
    baseZIndex: "10001"
};
exports.default = exports.styles;
//# sourceMappingURL=file-browser.scss.js.map